import type { AlertProps, AlertVariant } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { NumberField, SelectField, TextField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

const VARIANT = ["info", "success", "warning", "danger"] as const;

export function AlertInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as AlertProps;

  return (
    <>
      <SelectField
        label="Variant"
        value={p.variant ?? "info"}
        options={VARIANT}
        onChange={(v) => update(widget.id, { variant: v as AlertVariant })}
      />
      <TextField
        label="Title"
        value={p.title ?? ""}
        onChange={(v) => update(widget.id, { title: v || undefined })}
      />
      <TextField
        label="Message"
        value={p.message}
        multiline
        onChange={(v) => update(widget.id, { message: v })}
      />
      <TextField
        label="Icon (override)"
        value={p.icon ?? ""}
        onChange={(v) => update(widget.id, { icon: v || undefined })}
      />
      <NumberField
        label="Radius (px)"
        value={p.radius ?? 8}
        min={0}
        max={32}
        onChange={(v) => update(widget.id, { radius: v })}
      />
    </>
  );
}
